module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('defs', [_c('circle', {
    attrs: {
      "id": "a",
      "cx": "40",
      "cy": "40",
      "r": "40"
    }
  })]), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('mask', {
    attrs: {
      "id": "b",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#7F7F7F",
      "fill-rule": "nonzero",
      "xlink:href": "#a"
    }
  }), _c('path', {
    attrs: {
      "d": "M71 44.43C54.14 42.37 1.2 42 1 47.13c-.2 5.15 47.97 16.58 61.86 13.34 13.9-3.24 20.83-14.49 8.16-16.04z",
      "fill": "#DDCBBF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFD092",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M41.18 46.24l30.65-7.18-.4 3.05-.73.52h.73l-.2 2.87h-.66l.6.6-.14 2.28-29.85 7.78-1.4-2.8-.32-5.95z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#EFB875",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M70.57 40.84l-12.98 3.43 13.57-2.83zM70.7 42.63l-8.56 2.15 9.29-2.67zM46.9 49.25l20.68-3.22-9.49.85zM41.18 48.68l14.87-4.59-14.87 3.8zM41.18 53.16l7.72-1.13-7.72 2.45z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#DDA262",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M41.18 46.24l30.65-7.18-.04.51-30.6 7.8z"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.41 37.83l-.33 8.57.81.19c.24-2.08.73-5.44 1.12-5.92.54-.66 32.24 6.77 32.24 6.77v-1.17L7.41 37.83z",
      "fill": "#DDA262",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.01 40.58c-.39.47-.88 3.84-1.12 5.91l33.3 9.68v-3.03l-.94-.66h.94v-1.07l-1.07-.51h1.07v-1.62l-1.54-.55h1.54v-1.35s-31.64-7.43-32.18-6.8z",
      "fill": "#EFB875",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#DDA262",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M8.21 40.83l27.98 7.13-28.3-6.02v-1.1zM40.12 50.9l-20.9-5.78 21.96 4.95v.83zM10.28 44.69l23.38 5.15-12.45-1.7z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#7C0000",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M41.85 56.04l29.98-7.79v.57l-29.98 8.91z"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.46 38.83l-.33 7.38c0 .59.43 1 1.36 1.33l34.36 10.2v-1.7L7.62 46.46a.7.7 0 01-.46-.72l.25-6.68c0-.46 0-1 .84-.87l33.66 8.42v-1.54L7.55 36.92c-1.07 0-1.07 1.15-1.09 1.9z",
      "fill": "#5B0000",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#7C0000",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M41.85 45.07l30.5-6.93v.92l-30.5 7.55z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#960808",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M71.83 48.25l-30.65 7.23-33.56-9.02 34.23 9.58zM7.49 36.93l36.3-3.2 28.57 4.41-30.5 6.93z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFD092",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M42.13 32.34l24.3-2.78-.32 3.32-.58.42h.58l-.16 2.3h-.53l.48.48-.1 1.78-23.67 4.27-1.1-1.06-.28-7.77z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#EFB875",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M65.42 35.6L55.14 37.5l10.76-1.41zM65.53 33.3l-6.78.85 7.36-1.27zM46.66 37.76l16.4-2.6-7.53.68zM42.13 35.43L53.9 33.6 42.13 34.8zM42.13 40.88l6.12-.9-6.12 1.6z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#DDA262",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M42.13 32.34l24.3-2.78-.04.4-24.26 3.3zM15.36 28.2l-.27 7.65.64.14c.12-1.75.42-3.49.9-5.19.4-.53 25.5 2.46 25.5 2.46v-.92L15.36 28.2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.62 30.8c-.47 1.7-.77 3.44-.9 5.19l26.4 6.14v-1.25l-.72-.53h.73v-2.73l-.84-.41h.84v-1.3l-1.2-.47h1.2v-2.18s-25.1-3-25.5-2.46z",
      "fill": "#EFB875",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#DDA262",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M15.99 30.98l22.18 3.88-22.44-3v-.88zM41.29 37.21L24.7 34.43l17.43 2.12v.66zM17.62 34.52l18.55 3.7-9.89-1.37z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#E0682B",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M42.66 42.03l23.76-4.27v.45L42.66 43.4z"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.6 28.81l-.27 7c0 .46.33.8 1.07 1.06l27.26 6.58v-1.42l-27.14-6.11a.56.56 0 01-.4-.59l.2-5.82c0-.37 0-1.36.66-1.27l26.7 4.36V31.4L15.4 27.28c-.79 0-.79.92-.8 1.53z",
      "fill": "#893D09",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#E0682B",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M42.66 31.41l24.2-2.6v.75l-24.2 3.08zM66.42 37.76l-24.3 3.82-26.61-5.64 27.15 6.1z"
    }
  }), _c('path', {
    attrs: {
      "d": "M47.04 38.63c.5.07 1.2.78 1.68.48v-2.14c-.45.22-1.2-.45-1.63-.52-.16 0-.4.22-.62.53 0 .64 0 1.37.07 2.06.16-.25.35-.43.5-.4z",
      "fill": "#325677",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M48.02 40.88c.21-.2.46-.34.73-.42v-1.35c-.43.3-1.2-.4-1.67-.48-.15 0-.35.16-.55.4 0 .72.06 1.4.08 1.93.43.31 1.03.28 1.41-.08zM49.42 41.74c-.85.06-1.67.32-2.39.76.81.8 2.92 2.53 2.92 2.53v-1.54h1.63s-1.34-1-2.16-1.75z",
      "fill": "#254363",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M48.76 41.03v-.57c-.27.08-.52.23-.72.42-.4.38-1.01.41-1.45.08 0 .64.06 1.1.08 1.17.09.14.2.27.33.38.72-.44 1.54-.7 2.39-.76-.35-.34-.63-.61-.63-.72z",
      "fill": "#1E3A54",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M46.39 35.81v1.17c.21-.3.45-.55.62-.53.48.07 1.2.74 1.62.52v-2.11c-.83.08-1.62.41-2.24.95z",
      "fill": "#254363",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M46.35 34.75v1.04c.63-.54 1.4-.87 2.24-.96v-.43l-2.24.35z",
      "fill": "#1E3A54",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#EF713A",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M15.4 27.28l25.57-.45 25.88 1.98-24.19 2.6z"
    }
  }), _c('g', {
    attrs: {
      "mask": "url(#b)",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "M59.7 23.1s-.9-.24-1.12.11c-.18.47-.18.98 0 1.44.15.37 1.28.37 1.28.37l-.16-1.91z",
      "fill": "#254363"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.16 23.92s-17.19-1.44-18.13-1.3c-.95.16-.43 3.85 0 4.34.43.49 1.6.42.99-.97-.62-1.38-1.2-2.8-.55-2.9.64-.12 17.66 1.66 17.66 1.66l.03-.83z",
      "fill": "#254363"
    }
  }), _c('path', {
    attrs: {
      "d": "M44.18 23.2c-.74-.63-1.5 0-2.13.78v.87a6.6 6.6 0 001.32 3.5 2.5 2.5 0 002.36 1.21c.96-.07 1.8-.69 2.13-1.57a6 6 0 00.69-2.33c-1.39.3-3.18-1.46-4.37-2.46z",
      "fill": "#FFDCAE",
      "opacity": ".3"
    }
  }), _c('path', {
    attrs: {
      "d": "M48.54 24.27V23.97v-.12-.1V23.27a4.82 4.82 0 00-.78-1.32 7.38 7.38 0 00-.54-.76 2.5 2.5 0 00-2.36-1.21c-.96.07-1.8.69-2.13 1.57-.45.75-.7 1.6-.75 2.47.62-.83 1.39-1.4 2.13-.78 1.2 1 3.02 2.76 4.38 2.5.04-.45.04-.9 0-1.36l.05-.1z",
      "fill": "#FFDCAE",
      "opacity": ".4"
    }
  }), _c('path', {
    attrs: {
      "d": "M45.44 30.43a3.12 3.12 0 01-2.73-1.5 7.06 7.06 0 01-1.36-3.84 7 7 0 01.78-4.01 3.18 3.18 0 012.7-1.95c1.2-.1 2.37.48 3 1.5a7.07 7.07 0 011.42 3.83 7.1 7.1 0 01-.77 4 4.02 4.02 0 01-3.04 1.97zm-.5-10.13c-.91.14-1.68.71-2.05 1.52a5.09 5.09 0 00-.7 3.2c.07 1.22.5 2.4 1.25 3.4a2.4 2.4 0 002.26 1.15 2.38 2.38 0 002.04-1.5c.56-1.08.8-2.3.68-3.5a5.21 5.21 0 00-1.2-3.05 2.72 2.72 0 00-2.29-1.22z",
      "fill": "#254363"
    }
  }), _c('path', {
    attrs: {
      "d": "M45.96 29.99c.9-.14 1.67-.71 2.04-1.53.56-1.07.8-2.29.67-3.5a5.11 5.11 0 00-.98-2.73 6.27 6.27 0 01.07 5.85 2.38 2.38 0 01-2.04 1.5 2.4 2.4 0 01-2.26-1.16l-.12-.17c.12.2.24.39.39.56A2.7 2.7 0 0045.96 30zM41.61 25.43a6.9 6.9 0 01.78-4 3.18 3.18 0 012.7-1.95c1.2-.1 2.37.48 3 1.5l.16.22a5.74 5.74 0 00-.43-.62 3.22 3.22 0 00-2.99-1.49 3.2 3.2 0 00-2.7 1.94 7.02 7.02 0 00-.78 4c.05 1.31.46 2.58 1.2 3.68a7.59 7.59 0 01-.94-3.28z",
      "fill": "#31577A"
    }
  }), _c('path', {
    attrs: {
      "d": "M55.21 22.31c-.74-.61-1.5 0-2.12.8a6.69 6.69 0 001.31 4.41 2.5 2.5 0 002.36 1.22c.97-.08 1.8-.7 2.13-1.58.39-.72.63-1.52.7-2.33-1.36.26-3.18-1.5-4.38-2.52z",
      "fill": "#FFDCAE",
      "opacity": ".3"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.6 23.44v-.33-.13-.1-.45c-.12-.5-.32-.96-.6-1.4a6.3 6.3 0 00-.53-.75 2.49 2.49 0 00-2.36-1.24c-.97.07-1.8.7-2.13 1.58-.5.75-.81 1.6-.9 2.49.63-.84 1.4-1.41 2.13-.8 1.2 1.02 3.02 2.78 4.38 2.5.05-.45.05-.9 0-1.36h.02z",
      "fill": "#FFDCAE",
      "opacity": ".4"
    }
  }), _c('path', {
    attrs: {
      "d": "M56.51 29.56a3.13 3.13 0 01-2.78-1.52 7.01 7.01 0 01-1.31-3.77 7.06 7.06 0 01.77-4.02 3.2 3.2 0 012.71-1.93c1.2-.1 2.36.48 2.99 1.49a7.03 7.03 0 011.43 3.83 7.11 7.11 0 01-.77 4 4.03 4.03 0 01-3.04 1.92zM56 19.42c-.9.14-1.67.7-2.04 1.52a5.12 5.12 0 00-.7 3.2c.05 1.22.47 2.4 1.19 3.4a2.4 2.4 0 002.26 1.15 2.38 2.38 0 002.04-1.5c.57-1.1.8-2.33.68-3.55a5.11 5.11 0 00-1.2-3.04A2.64 2.64 0 0056 19.42z",
      "fill": "#254363"
    }
  }), _c('path', {
    attrs: {
      "d": "M57.03 29.1c.9-.13 1.67-.7 2.04-1.51.55-1.1.77-2.33.63-3.55a5.22 5.22 0 00-.99-2.73 6.21 6.21 0 01.05 5.82 2.38 2.38 0 01-2.04 1.5 2.4 2.4 0 01-2.26-1.15l-.12-.16.38.55a2.67 2.67 0 002.3 1.23zM52.68 24.6a6.97 6.97 0 01.78-4.01 3.2 3.2 0 012.7-1.93c1.2-.1 2.36.48 3 1.49l.16.2a5.59 5.59 0 00-.43-.6 3.21 3.21 0 00-3-1.5c-1.2.1-2.25.86-2.7 1.96a7.1 7.1 0 00-.77 4.06 7.3 7.3 0 001.2 3.67 7.59 7.59 0 01-.94-3.33z",
      "fill": "#31577A"
    }
  }), _c('path', {
    attrs: {
      "d": "M48.96 24.01s3.48.14 3.72-.49l.22 1.05s0 .52-3.96.53l.02-1.09z",
      "fill": "#254363"
    }
  }), _c('path', {
    attrs: {
      "d": "M51.08 24.44c-.4-.12 1.08-.46 1.2-.46.47 0-.45.7-1.2.46zM41.33 24.1s-.91-.26-1.13.08c-.18.46-.18.98 0 1.44.15.37 1.27.4 1.27.4l-.14-1.91z",
      "fill": "#31577A"
    }
  }), _c('path', {
    attrs: {
      "d": "M40.78 24.86s-17.16-1.84-18.1-1.75c-.92.08-.52 3.84 0 4.33.53.49 1.6.45 1.02-.95-.58-1.4-1.12-2.81-.48-2.92.65-.1 17.62 2.06 17.62 2.06l-.06-.77z",
      "fill": "#31577A"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7425f59d","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/dummy/MentoringDummyIcon.vue
// module id = 6c2ecb2ebfd38327c279
// module chunks = 89